import { render, staticRenderFns } from "./playlistVideos.vue?vue&type=template&id=095af4d0&"
import script from "./playlistVideos.vue?vue&type=script&lang=js&"
export * from "./playlistVideos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports